module.exports = __webpack_public_path__ + "assets/img/orange-tick.0d19bc79.svg";